module.exports = __webpack_public_path__ + "23e0f96c3fa45df393a3c1d184b2df34.svg";